/**
 * @generated SignedSource<<f78b6e9267ed7347dd68d21976ac45f1>>
 * @relayHash f7e4b1b64b705d39eed6fff39818c32d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bc9d26c60528e4eb53e695c9cacda4e982df6a48e1e9cd36bee5cd8be293e809

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldSchemeAssociatedFieldsInput = {
  nameOrDescriptionFilter?: string | null | undefined;
  schemeId: string;
};
export type FieldSchemePageQuery$variables = {
  cloudId: string;
  fieldSchemeAri: string;
  input: JiraFieldSchemeAssociatedFieldsInput;
};
export type FieldSchemePageQuery$data = {
  readonly fieldSchemeNode: {
    readonly " $fragmentSpreads": FragmentRefs<"AssociatedFieldsTable_scheme" | "PageHeader">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AssociatedFieldsTable">;
};
export type FieldSchemePageQuery = {
  response: FieldSchemePageQuery$data;
  variables: FieldSchemePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSchemeAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "kind": "Variable",
  "name": "input",
  "variableName": "input"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "fieldSchemeAri"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  },
  (v3/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "AssociatedFieldsTable"
      },
      {
        "alias": "fieldSchemeNode",
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "PageHeader"
              },
              {
                "kind": "FragmentSpread",
                "name": "AssociatedFieldsTable_scheme"
              }
            ],
            "type": "JiraFieldScheme"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
        "kind": "LinkedField",
        "name": "jira_fieldSchemeAssociatedFields",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraFieldSchemeAssociatedField",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "typeName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "fieldId"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFieldLocked"
                  },
                  (v6/*: any*/),
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "filters": [
          "cloudId",
          "input"
        ],
        "handle": "connection",
        "key": "associatedFieldsTable_adminPagesFieldScheme_jira_fieldSchemeAssociatedFields",
        "kind": "LinkedHandle",
        "name": "jira_fieldSchemeAssociatedFields"
      },
      {
        "alias": "fieldSchemeNode",
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "schemeId"
              },
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "projectsCount"
              }
            ],
            "type": "JiraFieldScheme"
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "bc9d26c60528e4eb53e695c9cacda4e982df6a48e1e9cd36bee5cd8be293e809",
    "metadata": {},
    "name": "FieldSchemePageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "07baa4df4274d364e20e4a75c3b37ae9";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
